const productsTable = {
	columns: {
		product: "Produto",
		fiscalCode: "SKU",
		category: "Categoria",
		categoryFilterButton: "Filtrar pela categoria {{categoryName}}",
		quantity: "Quantidade",
		lastUnitCost: "Último custo",
		avgUnitCost: "Custo médio",
		totalAvgCost: "Custo total",
		actions: {
			seeProductDetails: "Detalhes do produto",
			transferProduct: "Transferir produto",
			removeProduct: "Remover produto",
			ariaLabels: {
				button: "Ações do produto {{productName}}",
				details: "Ver detalhes do produto {{productName}}",
				transfer: "Transferir produto para outro estoque",
				remove: "Remover produto do estoque",
			},
		},
	},
	quantityInput: {
		add: "Adicionar quantidade de {{productName}}",
		remove: "Remover quantidade de {{productName}}",
		cannotRemove: "Não é possível remover quantidade pois o produto está zerado",
	},
};

const addStorageProductDrawer = {
	title: "Adicionar produto",
	successMessage: "Produto adicionado com sucesso!",
	errorMessage: "Erro ao adicionar produto ao estoque.",
	form: {
		product: "Produto",
		productPlaceholder: "Selecione o produto",
		quantity: "Quantidade",
		unitCostValue: "Preço de custo",
		unitCostValueType: "Valor por",
		totalCostValue: "Preço total",
		costValueByUnit: "Preço por {{unit}}",
		validation: {
			productIsRequired: "Selecione um produto",
			quantityMustBeGreaterThanZero: "A quantidade deve ser maior que zero",
			invalidQuantity: "Quantidade inválida",
			maxValue: "O valor máximo é {{maxValue}}",
		},
		actions: {
			cancel: "Cancelar",
			add: "Adicionar produto",
		},
	},
};

const importInvoiceDrawer = {
	title: "Importar XML",
	content: {
		title: "Importar XML de nota fiscal",
		subtitle: "Faça o upload do arquivo XML de uma nota fiscal de compra",
	},
	errorMessage: "Erro ao importar nota fiscal.",
	validation: {
		xmlRequired: "O arquivo XML é obrigatório.",
	},
	upload: {
		dropzoneTitle: "Arraste e solte o arquivo aqui",
		dropzoneSubtitle: "ou clique para selecionar o arquivo",
		fileDetails: "Tipo de arquivo: XML",
		uploadErrorMessage: "Não foi possível ler o arquivo.",
		invalidFileTitle: "Arquivo inválido",
		invalidFileReasonDefault: "O arquivo selecionado é inválido.",
		invalidFileReasonInvalidType: "Formato inválido. Formatos aceitos: {{formats}}",
	},
	actions: {
		cancel: "Cancelar",
		import: "Avançar",
	},
};

const adjustStorageProductDrawer = {
	input: {
		title: "Adicionar quantidades ao produto",
	},
	remove: {
		title: "Retirar quantidades do produto",
	},
	form: {
		product: "Produto",
		addQuantity: "Quantidade que deseja adicionar",
		removeQuantity: "Quantidade que deseja remover",
		unitCostValue: "Preço de custo",
		validation: {
			quantityMustBeGreaterThanZero: "A quantidade deve ser maior que zero",
			invalidQuantity: "Quantidade inválida",
			maxValue: "A quantidade máxima é {{maxValue}}",
		},
		actions: {
			cancel: "Cancelar",
			add: "Adicionar Quantidade",
			remove: "Retirar Quantidade",
		},
		productionRuleWarning: {
			title: "Atenção",
			description:
				"Este produto possui ficha técnica e seus itens serão reduzidos do estoque apenas quando estiverem zerados.",
		},
	},
	notifications: {
		success: {
			input: "Quantidades adicionadas com sucesso",
			remove: "Quantidades removidas com sucesso",
		},
		error: {
			input: "Erro ao adicionar quantidades",
			remove: "Erro ao remover quantidades",
		},
	},
};

export const storageV2 = {
	backButtonLabel: "Voltar para estoques",
	tabs: {
		products: {
			title: "Produtos do estoque",
			header: {
				filters: {
					search: {
						placeholder: "Buscar por produto",
					},
					category: {
						placeholder: "Filtrar por categoria",
						all: "Todas as categorias",
					},
					state: {
						placeholder: "Filtrar por estado de estoque",
						all: "Todos os produtos",
						zero: "Estoque zero",
						negative: "Estoque negativo",
					},
				},
				actions: {
					inventory: "Inventariar estoque",
					inventoryTitle: "Inventariar estoque",
					addProducts: "Adicionar produtos",
					addProductsTitle: "Adicionar produtos ao estoque",
					importXml: "Importar XML",
					importXmlTitle: "Importar XML de nota fiscal de compra",
					importViaExcel: "Importar via Excel",
					importViaExcelTitle: "Importar via Excel",
				},
			},
			totalizers: {
				productsInStock: "Produtos em estoque",
				totalCost: "Valor em estoque",
				productsWithoutCost: "Produtos com custo zerado",
				productsWithoutStock: "Produtos com qtd. zerada",
				seeProducts: "Ver produtos",
			},
			table: productsTable,
			addStorageProductDrawer,
			importInvoiceDrawer,
			adjustStorageProductDrawer,
			adjustProductUnitCostValue: {
				label: "Atualizar custo unitário de {{productName}}",
				disabledLabel:
					"Custo unitário de {{productName}} não pode ser atualizado, pois produto não possui estoque",
			},
			transferDrawer: {
				title: "Transferir produto {{productName}} do estoque",
				form: {
					label: {
						product: "Produto",
						fromStorage: "Retirando produtos do estoque",
						toStorage: "Transferindo produtos para o estoque",
						quantity: "Quantidade que deseja transferir",
					},
					placeholder: {
						toStorage: "Selecione o estoque",
					},
					hint: {
						maxQuantity: "Máximo disponível: {{maxQuantity}}",
					},
					sectionTitle: {
						chooseDestination: "Escolha o estoque de destino",
					},
					validation: {
						maxStorageCountIs: "Quantidade máxima em estoque é {{productMaxCountString}}",
						missingField: "Campo obrigatório",
						invalidQuantity: "Quantidade inválida",
					},
				},
				actions: {
					cancel: "Cancelar",
					submit: "Concluir transferência",
				},
				notifications: {
					success: "Transferência concluída com sucesso.",
				},
			},
			removeProductFromStorageDialog: {
				title: "Excluir produto",
				warningMessageSingle:
					"Certeza que deseja excluir o produto {{productName}} do estoque?",
				warningMessageMultiple:
					"Certeza que deseja excluir os {{count}} produtos do estoque?",
				warningMessageStrong: " Essa ação não pode ser desfeita",
				submit: "Excluir produto",
				notifications: {
					success: "Produto excluído do estoque com sucesso.",
				},
			},
		},
		inventory: {
			title: "Histórico de inventários",
		},
	},
};

export type StorageV2Translations = typeof storageV2;
